export type ProductInfo = {
  id: number;
  key: string;
  name: string;
  description: string;
  howItWorks: string;
  sideEffects: string;
  storage: string;
  pregnancy: string;
  drugInteractions: string;
  turnaroundTime: string;
  defaultDirections: string;
  supportsBatching: boolean;
  imageUrl: string;
  otherInfo: Record<string, any>;
  type: string;
  type2: string;
  administrationMethod: string;
  dosageForm: string;
  active?: boolean;
  strengths: {
    strength1?: string;
    strength2?: string;
    size?: string;
    dosage: string;
    duration: string;
    price: number;
    provider_price?: number | null;
  }[];
};

// Products are now loaded dynamically from the database
// This array is kept for type definitions and backwards compatibility
export const allProducts: ProductInfo[] = [];
